// Module
var code = "<div class=\"display-inline-block vert-middle padding0\">\n    <button class=\"md-button md-primary md-raised\" data-ng-click=\"ssa.schedule()\">Schedule</button>\n</div>\n";
// Exports
var _module_exports = code;;
var path = 'components/mechanic-public-services/actions/schedule-service-action.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;